import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import ProfileContactSectionWithCheckbox from '/component/partial/profile/ProfileContactSectionWithCheckbox';
import {withTranslation} from '/provider/TranslationProvider';
import {
  clientDetailsById,
  emailById,
  nameById,
  phoneNumberById,
  urlDetailsById,
} from '/redux/selector/candidate.selector';
import {withHOC} from '/util/hoc.util';

export default withHOC(
  connect(
    createStructuredSelector({
      name: nameById,
      accountEmail: emailById,
      phoneNumber: phoneNumberById,
      urlDetails: urlDetailsById,
      clientDetails: clientDetailsById,
    }),
  ),
  withTranslation('screen.candidateProfile.section.contact'),
)(ProfileContactSectionWithCheckbox);
